import React from 'react';
import CallScoreFactors from '../CallScore/HumanCallScoreReport/CallWrapUI/CallScoreFactors'
import CallScore from '../CallScore/HumanCallScoreReport/CallWrapUI/CallScore'
import Transcription from '../Transcription/Transcription'
// import {CallScore} from '@symblai/symbl-ui-components';
const MEETING_DETAILS_MENU = {
  CALLSCORE: 'callscore_menu',
  TRANSCRIPT: 'transcript_menu'
}

const MENU_ITEMS = [
  {
      key: MEETING_DETAILS_MENU.CALLSCORE,
      name: 'Call Score'
  },
  {
      key: MEETING_DETAILS_MENU.TRANSCRIPT,
      name: 'Transcription'
  }
]

const CallScoreReport = ({ callScoreResponse, messages, attendeesIdsWithIndex, onTryAnother, hideTranscript }) => {
  const [selectedMenu, setSelectedMenu] = React.useState(MEETING_DETAILS_MENU.CALLSCORE);

  const handleMenuClick = (menu) => {
    setSelectedMenu(menu);
  }

  const getHeader = () => {
    return (
      <div style={styles.header}>
        <h2>Call Score</h2>
        <button 
    onClick={onTryAnother}
          style={{
            backgroundColor: '#4285F4',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '100px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '400',
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }}
        >
          Try Another Call
        </button>      
      </div>
    )
  }

  if  (hideTranscript) {
    return (
      <>
        {getHeader()}
      <div className={"call-score-content"} style={{ margin: 0 }}>
        <p className={"call-score-summary"}>{callScoreResponse?.summary}</p>
        <CallScore callScore={callScoreResponse?.score} factors={callScoreResponse?.criteria} showColoredBackground={true} />
        <CallScoreFactors factors={callScoreResponse?.criteria}/>
      </div>
      </>
    )
  }

  return (
    <div className={"call-score-content"}>
            <div className={"menu-items"} style={{ backgroundColor: 'transparent'}}>
                {
                    MENU_ITEMS.map(({key, name}) => <div key={key} className={`${selectedMenu === key ? "active-menu-tab" : ""}`} onClick={() => handleMenuClick(key)}>
                        <p>{name}</p>
                        <div className={"highlight"}></div>
                    </div>)
                }
            </div>
            {
                selectedMenu === MEETING_DETAILS_MENU.CALLSCORE
                ? <>
                    <p className={"call-score-summary"}>{callScoreResponse?.summary}</p>
                    <CallScore callScore={callScoreResponse?.score} factors={callScoreResponse?.criteria} showColoredBackground={true} />
                    <CallScoreFactors factors={callScoreResponse?.criteria}/>
                </>
                : <Transcription messages={messages} attendeesIdsWithIndex={attendeesIdsWithIndex} showAutoScroll={false} />
            }
        </div>
    )
}

const styles = {
  container: {
    width: '100%',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
  },
  title: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#1E293B',
  },
  tryAnotherButton: {
    padding: '8px 16px',
    backgroundColor: '#2563EB',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
  },
};

export default CallScoreReport;